/*=========================================================================================
  File Name: moduleEmail.js
  Description: Email Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import state from "./moduleEmailState.js";
import mutations from "./moduleEmailMutations.js";
import actions from "./moduleEmailActions.js";
import getters from "./moduleEmailGetters.js";

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
